<template>
	<div class="xtxx">
		<div class="biaoqian">
			<div class="disfac jf">
				<img src="../../assets/wygl/wyf.png" alt="" style="height:20px;width:20px" />
				<span class="xqt">物业费缴纳</span>
			</div>
			<div class="yingjiao">
				<span style="font-size:35px">￥{{paysum}}</span>
				<span>应缴总额</span>
			</div>
			<van-cell-group>
				<van-field v-model="wyjf.villageName" label="小区名称" placeholder="暂无" input-align="right" readonly></van-field>
				<van-field v-model="wyjf.houseName" label="房屋信息" placeholder="暂无" input-align="right" readonly></van-field>
				<van-field v-model="wyjf.jzmj" label="房屋面积" placeholder="暂无" input-align="right" readonly></van-field>
				<div class="monicell ">
					<span class="monitit">计费区间</span>
					<div class="duoxuan">
						<van-checkbox-group v-model="result">
							<van-checkbox :name="item.chargeId" v-for="(item,index) in wyjf.details" :key="index">{{item.endMonth}}-{{item.startMonth}}   {{item.ppStatus}}:{{item.lstaccrbal}}</van-checkbox>
						</van-checkbox-group>
					</div>
				</div>
				<van-field v-model="wyjf.payAmount" label="支付方式" placeholder="云商通" input-align="right" readonly></van-field>
			</van-cell-group>
			<!-- <div class="tishi">
				<span>您已缴费至2021年06月，余额为0元，您的房屋面积是100.00㎡，海天物业费收费规则，每月缴费120.00元。</span>
			</div> -->
			<div class="bt md20" style="padding-bottom: 40px;">
				<button @click="add1()" class="btn" :class="{disab:paysum == 0}">提交</button>
			</div> 
		</div>
	</div>
</template>
<script>
	import Vue from 'vue';
	import {
		RadioGroup,Dialog,
		Radio,Checkbox, CheckboxGroup,Toast 
	} from 'vant';
	Vue.use(Toast);
	Vue.use(Dialog);
	Vue.use(Radio);
	Vue.use(Checkbox);
	Vue.use(CheckboxGroup);
	Vue.use(RadioGroup);
	import {
		mapState,
		mapMutations
	} from "vuex";
	export default {
		data() {
			return {
				// 物业缴费
				result:[],//计费区间的多选框
				wyjf: {},
				paysum:0,
				//  车位缴费
				cwjf: {
					placeType:'',//0是产权车位。1是租赁车位
					sectionStart: '',
					sectionEnd: '',
					payAmount: '',//实缴费用
					carId:'',
					placeId:'',
					expenseType: '', //车位租赁费,车位管理费
					ruleId:''
				},
				carlist:[],//当前房屋下的所有车位及车辆
				payAmounttypes:[],// 车位缴纳金额获得的数组对象
				showqsrq: false, //是否显示日期
				list: [],
				active: "", //tab切换的位置
				minDate: new Date(2020, 0, 1), //时间选择器值
				maxDate: new Date(2050, 0, 1), //时间选择器值
				currentDate: new Date(),
				loading: false, //列表加载的
				finished: false, //列表加载的
				refreshing: false, //列表加载的
				pageNum: 0
			};
		},
		computed: {
			...mapState(['userInfo', 'identity', 'houseId']),
		},
		mounted() {
			// 获取物业规则
			this.$axios.get('/api/v1/wygl/charge/wyf',{
				params:{
					token:sessionStorage.getItem('token')
				}
			}).then(res => {
				console.log(res)
				this.wyjf = res
			})
		},
		watch:{
			result(newval,oldval){
				var that = this
				that.paysum = 0
				var xzlist = that.wyjf.details.filter(item=>{
					return newval.includes(item.chargeId)
					
				})
				xzlist.forEach(element => {
					that.paysum += element.lstaccrbal
				});
			}
		},
		methods: {
			//物业缴费
			add1() {
				this.$axios.get('/api/v1/allinpay/createOrder/wyf',{
					params:{
						chargeIds: this.result.join(','),
						paySum:this.paysum
					} 
				})
				.then(result=>{
					console.log(result)
					if(result.code == '200006'){
						Dialog({ message:'错误：'+result.message}).then(()=>{
							this.$router.push({ path: "/wyfw/sjyz", query: {} });
						});
					}else{
						window.location.href = result
					}
				})
				// this.$axios({
				// 	url: "/api/v1/allinpay/createOrder/wyf",
				// 	method: "post",
				// 	data: {
				// 		chargeIds: this.result.join(','),
				// 		paySum:this.paysum
				// 	},
				// }).then((res) => {
				// 	if(res.code == '200006'){
				// 		this.$router.push({ path: "/wyfw/sjyz", query: {} });
				// 	}else if(res.code == '0'){
				// 		window.location.href = res.data
				// 	}
				// })
			},
		},
	};
</script>
<style lang="less" scoped>
	.tip {
		color: red;
		padding: 10px;
		font-size: 14px;
	}

	.van-tabs__wrap {
		position: fixed;
		top: 46px;
		right: 0;
		left: 0;
		z-index: 99;
		
	}
	.disab{
        pointer-events: none;
        cursor: default;
        opacity: 0.5;
    }
	.van-tabs__content{
		padding-top: 45px;
	}
	.monicell {
		width: 100%;
		display: flex;
		flex-direction: column;
		font-size: 14px;
		padding: 10px 16px;
		border-bottom: 1px solid #ebedf0;
		.duoxuan{
			margin-top: 10px;
			.van-checkbox{
				margin-top: 5px;
			}
		}
		.rq {
			width: 60%;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			font-size: 12px;
			input {
				outline: none;
				border: none;
				width: 40%;
				text-align: center;
			}

			input::-ms-input-placeholder {
				text-align: center;
			}

			input::-webkit-input-placeholder {
				text-align: center;
			}
		}
	}
	.yingjiao{
		height: 150px;
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.xtxx {
		width: 100%;
		background-color: #fff;

		.tingche {
			height: 20px;
			width: 20px;
			border-radius: 50%;
			border: #00a8ff 1px solid;
			color: #00a8ff;
			font-size: 15px;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.wdxx {
			margin: 26px 10px 26px 10px;
		}

		.biaoqian {
			width: 100%;
		}

		.pj {
			display: flex;
			width: 94%;
			height: 80px;
			border-radius: 10px;
			display: flex;
			align-items: center;
			box-shadow: 0px 0px 5px #e6e6e6;
			margin-top: 10px;
			position: relative;

			.xq {
				height: 100%;
				width: calc(98% - 70px);
				margin-left: 2%;
				display: flex;
				flex-direction: column;
				justify-content: center;

				.disfac {
					display: flex;
					align-items: center;
				}

				img {
					height: 20px;
					width: 20px;
				}

				.ml1 {
					margin-left: 30px;
				}

				.xqt {
					width: 70%;
					color: #333333;
					font-size: 15px;
					margin-left: 10px;
				}

				.xqn {
					width: 70%;
					margin-top: 5px;
					color: #999999;
					font-size: 12px;
				}

				.money {
					top: 35%;
					position: absolute;
					right: 5%;
					font-size: 20px;
				}
			}
		}

		.jf {
			margin-top: 10px;
			display: flex;
			align-items: center;
			img,
			span,
			div {
				margin-left: 10px;
			}
		}
		.tishi{
			width: 100%;
			padding: 10px 16px;
			color: #ff0000;
			font-size: 12px;
		}
		.search {
			width: 100%;
			height: 50px;
			display: block;
		}

		.van-tabs__line {
			background-color: #28aff6;
			width: 100px;
			border-radius: 5px;
		}

		.van-list {
			display: flex;
			flex-direction: column;
			align-items: center;
		}

		.wdxxitem {
			color: white;
			margin-top: 20px;
			font-weight: 600;
			height: 70px;
			width: 90%;
			display: flex;
			align-items: center;
			justify-content: center;
			background: #b7b7b7;
			border-radius: 10px;
		}

	}

	.bt {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.md20 {
		margin-bottom: 20px;
	}

	.btn {
		margin-top: 30px;
		outline: none;
		border: none;
		border-radius: 10px;
		color: white !important;
		font-weight: 600;
		background: #28aff6;
		height: 40px;
		width: 70%;
		cursor: pointer;
	}

	.red {
		color: #ee0a24;
	}
</style>
